import { PeopleRouteType } from 'mini-people-route-store';

export const CONTACT_DISTINGUISHED_FOLDER = 'Distinguished';
export const CONTACT_CUSTOM_FOLDER = 'Custom';

/** Returns the meta data for logging datapoint depending on the current folder */
export default function getPeopleHubFolderType(currentFolder: PeopleRouteType) {
    switch (currentFolder) {
        case PeopleRouteType.Contact:
        case PeopleRouteType.ContactList:
            return CONTACT_DISTINGUISHED_FOLDER;
        case PeopleRouteType.Folder:
            return CONTACT_CUSTOM_FOLDER;
        default:
            return '';
    }
}
